import { httpGet } from "@/utils/axios";
import urls from "@/utils/URLConstant";

export async function fetchReservation(reservationId?: string) {
  const id = reservationId || "68dc9abb006903ab86f974c8";
  if (!id) {
    throw new Error("reservationId is required to fetch reservation");
  }
  const response = await httpGet(urls.PREORDER.reservation(String(id)));
  // New contract: reservation endpoint returns only the reservation object
  return response.data;
}

const reservationService = { fetchReservation };
export default reservationService;
